import React, { useState } from 'react';
import { IioTable } from '../../components/IioTable';
import { useProjectPasswords, useCreatePassword, useDeletePassword } from '../../hooks/useProjectPasswords';
import { LoadingPlaceholder } from '../../components/LoadingPlaceholder';

export function PasswordsTab({ projectId }: { projectId: string }) {
  const { data: passwords = [], isLoading } = useProjectPasswords(projectId);
  const createPassword = useCreatePassword(projectId);
  const deletePassword = useDeletePassword(projectId);

  const [newPassword, setNewPassword] = useState('');

  const handleCreate = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newPassword) return;
    createPassword.mutate({ password: newPassword }, {
      onSuccess: () => setNewPassword(''),
    });
  };

  if (isLoading) return <LoadingPlaceholder />;

  return (
    <div>
      <h2><i className="fas fa-key" aria-hidden="true" /> Project Passwords</h2>

      <form onSubmit={handleCreate} noValidate>
        <div className="form-group">
          <div className="row">
            <div className="col-md-4">
              <input
                type="text"
                placeholder="Password"
                className="form-control"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                maxLength={255}
                disabled={createPassword.isPending}
              />
            </div>
            <div className="col-md-4">
              <button type="submit" className="btn btn-primary" disabled={createPassword.isPending}>
                Add password <i className="fas fa-plus-circle" aria-hidden="true" style={{ color: '#fff' }} />
              </button>
            </div>
          </div>
        </div>
      </form>

      {passwords.length === 0 && (
        <div className="alert alert-info alert-block">
          <h4>No passwords found</h4>
          <p>No passwords will be used when attempting to open password protected documents</p>
        </div>
      )}

      {passwords.length > 0 && (
        <div className="row">
          <div className="col-md-4">
            <IioTable>
              <colgroup>
                <col />
                <col style={{ width: 50 }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Password</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {passwords.map(pw => (
                  <tr key={pw.id}>
                    <td>{pw.password}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-xs btn-danger"
                        onClick={() => deletePassword.mutate(pw.id)}
                      >
                        <i className="fas fa-trash" aria-hidden="true" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </IioTable>
          </div>
        </div>
      )}
    </div>
  );
}
